import { X } from 'lucide-react';
import React, { ReactElement, useState } from 'react';
import { Waypoint } from 'react-waypoint';

import { Button } from 'src/components/ui/button';
import { Card } from 'src/components/ui/card';
import { Skeleton } from 'src/components/ui/skeleton';
import { cn } from 'src/lib/utils';

export function ConfigurationReferencesSkeleton(): ReactElement {
  const [topShadow, setTopShadow] = useState(true);
  const [bottomShadow, setBottomShadow] = useState(true);

  return (
    <>
      <span className='absolute right-1 top-2 flex items-center gap-1 text-sm font-medium text-layout-foreground-secondary'>
        <Skeleton className='mt-1 h-4 w-10' />
      </span>
      <Card className='relative flex flex-1 flex-col gap-2 overflow-hidden'>
        <div
          className={cn(
            'flex flex-1 flex-col gap-2 overflow-y-auto pb-2 pl-6 pr-4',
            topShadow && !bottomShadow && 'mask-fade-top',
            bottomShadow && !topShadow && 'mask-fade-bottom',
            topShadow && bottomShadow && 'mask-fade',
          )}
        >
          <Waypoint
            onEnter={() => setTopShadow(false)}
            onLeave={() => setTopShadow(true)}
          />
          {Array.from({ length: 17 }).map((_, index) => (
            <div
              className='flex flex-row items-center justify-between gap-2'
              key={index}
            >
              <div className='flex flex-row items-center justify-between gap-2'>
                <Skeleton className='h-4 w-10' />
                <Skeleton className='h-4 w-80' />
              </div>
              <div className='flex flex-row items-center justify-between gap-4'>
                <Button disabled variant='ghost' size='icon'>
                  <X className='h-4 w-4' />
                </Button>
              </div>
            </div>
          ))}
          <Waypoint
            onEnter={() => setBottomShadow(false)}
            onLeave={() => setBottomShadow(true)}
          />
        </div>
      </Card>
    </>
  );
}
